module.exports = __webpack_public_path__ + "img/bag-plus-fill.1ff4cf4b.svg";